import React from 'react';
import {
  CircularProgress,
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material';
import clsx from 'clsx';

import { CustomIcon, IconLabelPositionEnum } from 'components/CustomIcon';
import * as Styled from './IconButton.styles';
import { IconType } from '../../CustomIcon/CustomIcon.config';

export type IconButtonProps = MuiIconButtonProps & {
  iconName: IconType;
  dense?: boolean;
  iconLabel?: string;
  labelPosition?: IconLabelPositionEnum | null;
  isLoading?: boolean;
  badge?: string | number;
  isStartIconCircularProgress?: boolean;
};

// @ts-ignore // TODO: fix types
const IconButton: React.FC<IconButtonProps> = React.forwardRef(
  (
    {
      iconName,
      dense,
      iconLabel,
      labelPosition = IconLabelPositionEnum.Start,
      isLoading = false,
      isStartIconCircularProgress = false,
      badge,
      ...restProps
    },
    ref,
  ) => {
    const buttonCustomClasses = clsx({
      isLoading,
      isDense: Boolean(dense),
      withLabel: Boolean(iconLabel),
    });

    return (
      <MuiIconButton
        classes={{ root: buttonCustomClasses }}
        aria-label={iconName}
        {...restProps}
        ref={ref}
      >
        {isStartIconCircularProgress ? (
          <CircularProgress size={1} />
        ) : (
          <CustomIcon
            name={iconName}
            dense={Boolean(dense)}
            label={iconLabel}
            labelPosition={labelPosition}
          />
        )}
        {badge ? <Styled.Badge>{badge}</Styled.Badge> : null}
      </MuiIconButton>
    );
  },
);

IconButton.displayName = 'IconButton';
export default IconButton;
